import React from "react";

/* Admin-assigned title badges shown wherever user identity appears.
 * Style presets are wired to the backend `title_style` field. */
const STYLES = {
  blue:   { bg: "linear-gradient(135deg, rgba(0,175,255,0.18), rgba(0,102,204,0.15))", border: "rgba(0,175,255,0.55)", text: "#7DD3FF" },
  gold:   { bg: "linear-gradient(135deg, rgba(255,215,0,0.18), rgba(255,140,0,0.15))", border: "rgba(255,215,0,0.55)", text: "#FFD700" },
  teal:   { bg: "linear-gradient(135deg, rgba(20,184,166,0.18), rgba(6,148,162,0.15))", border: "rgba(20,184,166,0.55)", text: "#5EEAD4" },
  silver: { bg: "linear-gradient(135deg, rgba(226,232,240,0.18), rgba(148,163,184,0.15))", border: "rgba(226,232,240,0.55)", text: "#E2E8F0" },
  rose:   { bg: "linear-gradient(135deg, rgba(244,63,94,0.18), rgba(225,29,72,0.15))", border: "rgba(244,63,94,0.55)", text: "#FB7185" },
  violet: { bg: "linear-gradient(135deg, rgba(139,92,246,0.18), rgba(124,58,237,0.15))", border: "rgba(139,92,246,0.55)", text: "#C4B5FD" },
  green:  { bg: "linear-gradient(135deg, rgba(34,197,94,0.18), rgba(22,163,74,0.15))", border: "rgba(34,197,94,0.55)", text: "#86EFAC" },
};

export const TITLE_STYLE_OPTIONS = [
  { id: "blue",   label: "Blue (VIP)" },
  { id: "gold",   label: "Gold (Founder)" },
  { id: "teal",   label: "Teal (Moderator)" },
  { id: "silver", label: "Silver (Pro)" },
  { id: "green",  label: "Green (Verified)" },
  { id: "rose",   label: "Rose (Artist)" },
  { id: "violet", label: "Violet (Beta)" },
];

export default function TitleBadge({ user, size = "sm", className = "", testId }) {
  const badge = user?.title_badge;
  if (!badge?.text) return null;
  const style = STYLES[badge.style] || STYLES.blue;
  const isSm = size === "sm";
  return (
    <span
      data-testid={testId || `title-badge-${badge.style}`}
      className={`inline-flex items-center gap-1 rounded-full font-display font-black uppercase tracking-wider whitespace-nowrap border ${isSm ? "px-1.5 py-0.5 text-[9px]" : "px-2 py-0.5 text-[10px]"} ${className}`}
      style={{ background: style.bg, borderColor: style.border, color: style.text }}
    >
      {badge.text}
    </span>
  );
}

export function titleColorOf(user) {
  const s = STYLES[user?.title_badge?.style];
  return s ? s.text : null;
}
